import Vue from 'vue';
import App from './App.vue';

function onSignIn (googleUser) {
    console.log(googleUser, "<<<googleUser")
    // this.$emit('googleLogin', googleUser)
}

new Vue({
    render: h => h(App)
}).$mount('#app');
